class DeleteTestSuiteController {
    constructor(toastr, ModalService, ManageTestSuiteServiceApi) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.testSuite) {
                this.testSuite = changes.testSuite.currentValue;
            }
        };
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.testSuite = {};
                if (angular.isUndefined(this.testSuite)) {
                    this.toastr.error('Test Suite is undefined');
                }
                this.isInitialized = true;
            }
        };
        this.deleteSuite = () => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Delete Test Suite',
                bodyText: 'Are you sure you want to delete ' + this.testSuite.TestSuiteName + ' ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                // Wait for user to decide if the TestSuite should be deactivated
                this.ManageTestSuiteServiceApi.deleteTestSuite(this.testSuite.Id).then((response) => {
                    let deleteResult = response.data;
                    let succeeded = deleteResult === true;
                    if (succeeded) {
                        this.testSuite.IsDeleted = true;
                    }
                    const msg = [
                        'Test Suite ',
                        this.testSuite.TestSuiteName,
                        ' deleted!'
                    ].join('');
                    this.onSuccess({ testSuite: this.testSuite });
                    this.toastr.info(msg);
                }, () => {
                    const reason = 'Failed to delete Test Suite .';
                    this.onError({ testSuite: this.testSuite });
                    this.toastr.error(reason, 'User Error');
                });
            });
        };
        this.toastr = toastr;
        this.ModalService = ModalService;
        this.ManageTestSuiteServiceApi = ManageTestSuiteServiceApi;
    }
}
// component deletes the test suite passed in and makes the API call to mark it as deleted
// when the button is clicked.
angular.module('app').component('deleteTestSuite', {
    bindings: {
        testSuite: '<',
        onSuccess: '&',
        onError: '&'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/delete-test-suite.tpl.html',
    controllerAs: 'vm',
    controller: DeleteTestSuiteController
});
